/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Noexplicitopeninghours3Inputs */

const en_noexplicitopeninghours3 = /** @type {(inputs: Noexplicitopeninghours3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No fixed opening hours`)
};

const de_noexplicitopeninghours3 = /** @type {(inputs: Noexplicitopeninghours3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine festen Öffnungszeiten`)
};

/**
* | output |
* | --- |
* | "No fixed opening hours" |
*
* @param {Noexplicitopeninghours3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const noexplicitopeninghours3 = /** @type {((inputs?: Noexplicitopeninghours3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Noexplicitopeninghours3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_noexplicitopeninghours3(inputs)
	return de_noexplicitopeninghours3(inputs)
});
export { noexplicitopeninghours3 as "noExplicitOpeningHours" }